module.exports = __webpack_public_path__ + "img/bow width.51c171ef.png";